import React from "react";
import { t } from "ttag";

import { useAppDispatch } from "../../../store/reducers";
import { CustomerDetails } from "../CustomerDetails";
import { FormView } from "../FormView";
import { ICustomerSummary } from "../models";
import { viewStackPush } from "../reducers";

const generateRandomString = (len: number) => {
    const s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array(len)
        .join()
        .split(",")
        .map(() => {
            return s.charAt(Math.floor(Math.random() * s.length));
        })
        .join("");
};

export const CustomerCreate = (): React.ReactNode => {
    const dispatch = useAppDispatch();
    return (
        <FormView
            baseURL={"/api/csr/users/"}
            fields={[
                {
                    label: t`Username`,
                    name: "username",
                    type: "text",
                    isRequired: true,
                },
                {
                    label: t`First Name`,
                    name: "first_name",
                    type: "text",
                },
                {
                    label: t`Last Name`,
                    name: "last_name",
                    type: "text",
                },
                {
                    label: t`Email Address`,
                    name: "email",
                    type: "text",
                },
            ]}
            initialValues={{
                username: generateRandomString(30),
            }}
            onPostSave={async (customer: ICustomerSummary) => {
                const component = <CustomerDetails url={customer.url} />;
                dispatch(
                    viewStackPush({ name: t`Customer Details`, component }),
                );
            }}
        />
    );
};
